import React, { useState, useEffect } from "react";

import { getTemplateShiftFilter } from "../api/template_shift";
import { getMyGroupStaion } from "../api/group_staion";
import { GetStationsByIdGroup } from "../api/station";
import { addShift } from "../api/shift";

const ShiftRegistration = ({ token }) => {
  const [groupStationList, setGroupStationList] = useState([]);
  const [stationList, setStationList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState([]);
  const [messageType, setMessageType] = useState("success");
  const [selectedTemplateShift, setSelectedTemplateShift] = useState("");
  const [disabled, setDisabled] = useState(true);

  const [date, setDate] = useState("");
  const [groupStation, setGroupStation] = useState(0);
  const [station, setStation] = useState(0);
  const [templateShift, setTemplateShift] = useState([]);

  const selectedShift = templateShift.find(
    (ts) => String(ts.id) === String(selectedTemplateShift),
  );

  const fetchFields = async () => {
    try {
      setLoading(true);
      const response = await getMyGroupStaion(token);
      setGroupStationList(response);
      setStationList([]);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFields();
  }, [token]);

  async function selectDate(event) {
    let groupStationNow;
    let stationNow;

    setDate(event.target.value);
    if (/^-?\d+$/.test(event.target.value)) {
      setGroupStation(event.target.value);
      groupStationNow = event.target.value;
    } else {
      setGroupStation("");
      groupStationNow = null;
    }
    if (/^-?\d+$/.test(event.target.value)) {
      setStation(event.target.value);
      stationNow = event.target.value;
    } else {
      setStation("");
      stationNow = null;
    }
    setDisabled(false);
    const data = await getTemplateShiftFilter(
      token,
      event.target.value,
      groupStationNow,
      stationNow,
    );
    setTemplateShift(data);
  }

  async function selectGroupStation(event) {
    let groupStationNow;
    const value = event.target.value;
    if (value != 0) {
      setGroupStation(event.target.value);

      const stations = await GetStationsByIdGroup(token, value);
      setStationList(stations);
      groupStationNow = event.target.value;
    } else {
      setGroupStation("");
      groupStationNow = null;
      setStationList([]);
    }
    const data = await getTemplateShiftFilter(
      token,
      date,
      groupStationNow,
      station,
    );
    setTemplateShift(data);
  }

  async function selectStation(event) {
    let stationNow;
    if (/^-?\d+$/.test(event.target.value)) {
      setStation(event.target.value);
      stationNow = event.target.value;
    } else {
      setStation("");
      stationNow = null;
    }
    const data = await getTemplateShiftFilter(
      token,
      date,
      groupStation,
      stationNow,
    );
    setTemplateShift(data);
  }

  async function selectTemplateShift(event) {
    setSelectedTemplateShift(event.target.value);
  }

  async function recordShift() {
    if (selectedTemplateShift == "" || selectedTemplateShift == "default") {
      setMessageType("error");
      setMessage(["Не выбран шаблон смены"]);
      return;
    }
    const shift = await addShift(token, selectedTemplateShift);
    setDate("");
    setGroupStation(0);
    setStation(0);
    setTemplateShift([]);
    setSelectedTemplateShift(0);
    setStationList([]);
    setDisabled(true);

    setMessageType("success");
    setMessage([
      `Вы записаны на смену на ${shift.date}`,
      `c ${shift.start} до ${shift.end} на станции ${shift.station_name}`,
    ]);
  }

  return (
    <div className="add-shift-page">
      <div className="add-shift-card">
        <header className="add-shift-header">
          <h1>Запись на смену</h1>
          <p className="add-shift-hint">
            Выберите дату, станцию и свободный шаблон смены
          </p>
        </header>

        {loading ? (
          <div className="add-shift-loading text-center py-5">
            <div
              className="spinner-border"
              style={{ color: "#fd0429" }}
              role="status"
            >
              <span className="visually-hidden">Загрузка...</span>
            </div>
            <p className="text-muted mt-2 mb-0">Загрузка...</p>
          </div>
        ) : (
          <form className="add-shift-form" onSubmit={(e) => e.preventDefault()}>
            <div className="add-shift-step">
              <span className="add-shift-step-num">1</span>
              <div className="add-shift-step-body">
                <label className="form-label" htmlFor="add-shift-date">
                  Дата смены
                </label>
                <input
                  className="form-control"
                  type="date"
                  id="add-shift-date"
                  value={date}
                  onChange={selectDate}
                />
                <div className="form-text">Смены доступны на выбранный день</div>
              </div>
            </div>

            <div className="add-shift-step">
              <span className="add-shift-step-num">2</span>
              <div className="add-shift-step-body">
                <label className="form-label" htmlFor="add-shift-group">
                  Группа станций
                </label>
                <select
                  className="form-select"
                  id="add-shift-group"
                  onChange={selectGroupStation}
                  value={groupStation}
                  disabled={disabled}
                >
                  <option value={0}>Выберите группу станций</option>
                  {groupStationList.map((group) => (
                    <option key={group.id} value={group.id}>
                      {group.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="add-shift-step">
              <span className="add-shift-step-num">3</span>
              <div className="add-shift-step-body">
                <label className="form-label" htmlFor="add-shift-station">
                  Станция
                </label>
                <select
                  className="form-select"
                  id="add-shift-station"
                  onChange={selectStation}
                  value={station}
                  disabled={disabled || groupStation === 0}
                >
                  <option value={0}>Выберите станцию</option>
                  {stationList.map((st) => (
                    <option key={st.id} value={st.id}>
                      {st.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="add-shift-step">
              <span className="add-shift-step-num">4</span>
              <div className="add-shift-step-body">
                <label className="form-label" htmlFor="add-shift-template">
                  Шаблон смены
                </label>
                <select
                  className="form-select"
                  id="add-shift-template"
                  onChange={selectTemplateShift}
                  value={selectedTemplateShift}
                  disabled={disabled}
                >
                  <option value={0}>Выберите шаблон смены</option>
                  {templateShift &&
                    templateShift.map((ts) => (
                      <option key={ts.id} value={ts.id}>
                        {ts.start} – {ts.end} · {ts.hours} ч · {ts.station_name}{" "}
                        · {ts.restaurant_name}
                      </option>
                    ))}
                </select>
                {templateShift?.length === 0 && date && !disabled && (
                  <div className="form-text text-warning">
                    Нет свободных шаблонов по выбранным фильтрам
                  </div>
                )}
              </div>
            </div>

            {selectedShift && (
              <div className="add-shift-preview">
                <div className="add-shift-preview-title">Выбранная смена</div>
                <dl className="add-shift-preview-details">
                  <div>
                    <dt>Дата</dt>
                    <dd>{selectedShift.date || date}</dd>
                  </div>
                  <div>
                    <dt>Время</dt>
                    <dd>
                      {selectedShift.start} – {selectedShift.end} (
                      {selectedShift.hours} ч)
                    </dd>
                  </div>
                  <div>
                    <dt>Станция</dt>
                    <dd>{selectedShift.station_name}</dd>
                  </div>
                  <div>
                    <dt>Ресторан</dt>
                    <dd>{selectedShift.restaurant_name}</dd>
                  </div>
                </dl>
              </div>
            )}

            <button
              type="button"
              className="btn add-shift-submit w-100"
              data-bs-toggle="modal"
              data-bs-target="#addShiftResultModal"
              onClick={recordShift}
              disabled={disabled}
            >
              Записаться
            </button>
          </form>
        )}
      </div>

      <div
        className="modal fade"
        id="addShiftResultModal"
        tabIndex="-1"
        aria-labelledby="addShiftResultModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content add-shift-modal">
            <div className="modal-header border-0 pb-0">
              <h5 className="modal-title" id="addShiftResultModalLabel">
                {messageType === "success"
                  ? "Смена записана"
                  : "Не удалось записаться"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Закрыть"
              />
            </div>
            <div className="modal-body text-center pt-2">
              <div
                className={`add-shift-modal-icon ${
                  messageType === "success"
                    ? "add-shift-modal-icon--success"
                    : "add-shift-modal-icon--error"
                }`}
              >
                {messageType === "success" ? "✓" : "!"}
              </div>
              {message.map((line, i) => (
                <p
                  key={i}
                  className={`mb-1 ${
                    messageType === "error" ? "text-danger" : "text-body"
                  }`}
                >
                  {line}
                </p>
              ))}
            </div>
            <div className="modal-footer border-0 pt-0">
              <button
                type="button"
                className="btn add-shift-submit w-100"
                data-bs-dismiss="modal"
              >
                Понятно
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShiftRegistration;
